import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { AdminGetLiveStreamsResponse } from '@/models/apis/movie/movieResponse';

export default {
  adminGetLiveStreams(): Promise<AxiosResponse<AdminGetLiveStreamsResponse>> {
    return axios.get(utils.getApiUrl('/admin/live_streams'));
  },
};
